
    import {Component, Prop} from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import {CurrentUserProfileEditDto} from "@/Areas/AppAreaName/Views/admin/entities/CurrentUserProfileEditDto";
    import AppConsts from '@/lib/appconst';
    import SmsVerification from "@/Areas/AppAreaName/Views/admin/profile/sms-verification.vue";

    interface InitialVals {
        isGoogleAuthenticatorEnabled: boolean,
        isPhoneNumberConfirmed: boolean,
        isPhoneNumberEmpty: boolean,
        smsEnabled: boolean,
        showTimezoneSelection: boolean,
        canChangeUserName: boolean,
        defaultTimezoneScope: number,
        initialTimezone: string
    }

    @Component({
        components: {
            SmsVerification
        }
    })
    export default class MySettings extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean;
        showSmsVericationModal: boolean = false;
        initial: InitialVals = <InitialVals>{};
        userProfile: CurrentUserProfileEditDto = <CurrentUserProfileEditDto>{};

        async smsVerify() {
            await this.$store.dispatch('profile/sendVerificationSms')
                .then(rs => {
                    this.showSmsVericationModal = true;
                }).catch(reason => {
                    this.$Notice.error({
                        title: '发送验证消息失败!',
                        desc: reason.response.statusText
                    })
                })
        }

        changePhoneNumberToVerified() {
            this.initial.isPhoneNumberConfirmed = true;
        }

        handleTabClick() {
        }

        async updateQrCodeSetupImageUrl() {
            await this.$store.dispatch('profile/updateGoogleAuthenticatorKey')
                .then(rs => {
                    this.userProfile.qrCodeSetupImageUrl = rs.qrCodeSetupImageUrl;
                    this.initial.isGoogleAuthenticatorEnabled = true;
                }).catch(reason => {
                    this.$Notice.error({
                        title: '获取Google认证信息失败!',
                        desc: reason.response.statusText
                    })
                })
        }

        cancel() {
            this.$emit('input', false);
        };

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$store.dispatch('profile/getCurrentUserProfileForEdit')
                    .then(rs => {
                        this.userProfile = this.$store.state.profile.currentUserProfileEditDto;
                        this.initial.smsEnabled = abp.setting.getBoolean(
                            'App.UserManagement.SmsVerificationEnabled'
                        );
                        this.initial.initialTimezone = this.userProfile.timezone;
                        this.initial.canChangeUserName =
                            this.userProfile.userName != AppConsts.userManagement.defaultAdminUserName;
                        this.initial.isGoogleAuthenticatorEnabled =
                            this.userProfile.isGoogleAuthenticatorEnabled;
                        this.initial.isPhoneNumberConfirmed =
                            this.userProfile.isPhoneNumberConfirmed;
                        this.initial.isPhoneNumberEmpty = this.userProfile.phoneNumber === '';
                    }).catch(reason => {
                        this.$Notice.error({
                            title: '获取登录信息失败!',
                            desc: reason.response.statusText || reason.message
                        })
                    })
            }
        };

        save() {
            (this.$refs.mySettingsForm as any).validate(valid => {
                if (valid) {
                    this.$store.dispatch('profile/updateCurrentUserProfile',this.userProfile)
                        .then(rs => {
                            if (abp.clock.provider.supportsMultipleTimezone &&
                                this.initial.initialTimezone !== this.userProfile.timezone) {
                                this.$Notice.info(
                                    {
                                        title: '!',
                                        desc: this.L('TimeZoneSettingChangedRefreshPageNotification')
                                    }
                                );
                                window.location.reload();
                            }
                            this.$Notice.success({
                                title: '更新个人信息成功!'
                            })
                            this.$emit('input', false);
                        }).catch(reason => {
                        this.$Notice.error({
                            title: '获取登录信息失败!',
                            desc: reason.response.statusText
                        })
                    })
                }
            });
        }

        rules = {
            name: [
                {
                    required: true,
                    message: this.L('TheFieldIsRequired', this.L('Name')),
                    trigger: 'blur,change'
                }
            ],
            surname: [
                {
                    required: true,
                    message: this.L('TheFieldIsRequired', this.L('Surname')),
                    trigger: 'blur,change'
                }
            ],
            emailAddress: [
                {
                    type: 'email',
                    required: true,
                    message: this.L('EnterAValidEmail', this.L('EmailAddress')),
                    trigger: 'change, blur'
                }
            ],
            userName: [
                {
                    required: true,
                    message: this.L('TheFieldIsRequired', this.L('UserName')),
                    trigger: 'blur,change'
                }
            ]
        };
    };
